import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

import { notificationsStoreModule } from '@listen360/alexandria'

import { MUTATIONS_TO_PERSIST } from '@/store/constants'
import * as organization from '@/store/modules/organization'
import * as reports from '@/store/modules/reports'
import * as user from '@/store/modules/user'

Vue.use(Vuex)

const vuexPersist = new VuexPersist({
  key: 'sparta',
  storage: localStorage,
  reducer: state => {
    const newState = {
      user: {
        currentEnvironmentId: state.user.currentEnvironmentId,
        currentSubsidiary: state.user.currentSubsidiary
      }
    }
    return newState
  },
  filter: mutation => {
    const mutationToPersist = MUTATIONS_TO_PERSIST.find(
      mtp => mtp === mutation.type
    )
    return Boolean(mutationToPersist)
  }
})

const store = new Vuex.Store({
  modules: {
    reports,
    user,
    notifications: notificationsStoreModule,
    organization
  },
  plugins: [vuexPersist.plugin]
})

export default store
